module.exports = __webpack_public_path__ + "icons/original/large/large-a5.e5df7839ecedea6b66da59aa3ece9ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a5.png
// module id = TeOI
// module chunks = app